import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { TranslationService } from "@app/services/translation.service";
import { VButtonDropdownComponent } from "@directives/_core/v-dropdown/v-button-dropdown/v-button-dropdown.component";
import { FilterTriggerType, IFilterBarFilter } from "../filter-bar.models";
import "./vehicle-type-button-filter.component.scss";
import { VehicleType } from "@app/enum/VehicleType.enum";
import { FilterBarComponent } from "../filter-bar.component";

export interface IKeyValuePair  {
    id: number;
    value: string;
}

@Component({
    selector: "vehicle-type-button-filter",
    template: require("./vehicle-type-button-filter.component.html")
})
export class VehicleTypeButtonFilterComponent implements IFilterBarFilter<IKeyValuePair> {
    @Input() selected: IKeyValuePair;
    @Input() label;
    @Output() change = new EventEmitter<IKeyValuePair>();

    @ViewChild(VButtonDropdownComponent) dropdown: VButtonDropdownComponent;

    name = this.translationService.t("FilterBar.ResourceType");
    icon = "fa-solid fa-duotone fa-car";
    type: FilterTriggerType = "vehicletype";
    vehicleTypes: IKeyValuePair[] = [];
  
    constructor(
        readonly parent: FilterBarComponent,
        readonly elementRef: ElementRef<HTMLElement>,
        private readonly translationService: TranslationService
    ) {
    }

    onFilterOpen(): void {
       if(this.vehicleTypes?.length){
            return;
        }
        
        for (const type in VehicleType) {
            if (isNaN(Number(type))) {
                this.vehicleTypes.push({id: Number(VehicleType[type]), value: this.translationService.t(`VehicleTypeEnum.${type}`)})
            };
        }
    }
    
    filterPredicate(item: any, vehicleType?: IKeyValuePair): boolean {        
        if (item.vehicle) {
            return item.vehicle.VehicleType === vehicleType.id;
        }

        if (item.Vehicle) {
            return item.Vehicle.VehicleType === vehicleType.id;
        }

        if (item.Reg) {
            return item.VehicleType === vehicleType.id;
        }

        return false;
    }

    searchPredicate = (item: IKeyValuePair, value?: any): boolean => {
        return item.value.toLowerCase().includes(value.toLowerCase());
    }

    onVehicleTypeClick(vehicleType: IKeyValuePair): void {
        this.selected = vehicleType;
        this.change.emit(this.selected);
        this.parent.onFilterChange("vehicletype", vehicleType);

        if (this.selected) {
            this.label = vehicleType.value
        }
    }

    clearSelectedVehicleType(): void {
        this.onVehicleTypeClick(null);
    }
}
